export default __webpack_public_path__ + "static/media/IMG_7114.c3be122b.jpeg";